const MonitorTravel = () => import('@/views/monitor_travel/MonitorTravel');
const TravelOverview = () => import('@/views/dashboard/types/DashboardType1');

const mainWidget = [
  {
    title: 'ติดตามเฝ้าระวังการเดินทางเข้าประเทศ',
    path: '/admin/dashboard/monitor-travel',
    component: MonitorTravel
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})